/**
 * 时间戳转会员到期时间
 * @export
 * @param {number} timestamp 时间戳
 * @returns
 */
export function vipExpireFormatter(timestamp) {
  // YYYY/M/D
  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  return `${year}-${month}-${day}`
}
